<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-02 09:07:09
 * @LastEditTime: 2021-01-05 10:35:41
-->
<template>
  <div class="home">
    <div>
      <el-button :type="allBtn" size="mini" @click="changeTab('all')">{{$t('lang.Monitor.systemOverview')}}</el-button>
      <el-button :type="devicesBtn" size="mini" @click="changeTab('configuration')">{{$t('lang.Monitor.deviceConfiguration')}}</el-button>
    </div>
    <!-- 组件缓存，切换时根据缓存生命周期来开启/关闭计时器，减少过多的请求，在哪个组件就只是开启哪一个组件的计时器 -->
    <keep-alive>
      <component :is="currentCompont"></component>
    </keep-alive>
  </div>
</template>
<script>
import deviceConfiguration from './components/deviceConfiguration/index'
import systemOverview from './components/systemOverview/index'
import { getPermission } from '@/cookie/cookie'
export default {
  name: 'CloudDashboard',
  data() {
    return {
      // 权限
       Permission: [],
      // 设备组态按钮状态
      devicesBtn: '',
      allBtn: 'success',
      devicesTab: false,
      allTab: true,
    }
  },
  mounted() {
    this.Permission = getPermission();
    if(this.Permission.indexOf(207) === -1) { // 都没权限则默认显示系统总览并提示
      this.$message.warning('权限不足，无权操作！')
      this.devicesBtn = ''
      this.allBtn = 'success'
    }else if(this.Permission.indexOf(211) === -1) { // 系统总览权限不足优先显示设备组态
      this.$message.warning('权限不足，无权操作！')
      this.devicesBtn = 'success'
      this.allBtn = ''
      this.devicesTab = true
      this.allTab = false
    }else{
      this.devicesBtn = ''
      this.allBtn = 'success'
      this.devicesTab = false
      this.allTab = true
    }
  },
  components: {
    deviceConfiguration,
    systemOverview
  },
  computed: {
    currentCompont() {
      if(this.allBtn) {
        return 'systemOverview'
      }else{
        return 'deviceConfiguration'
      }
    }
  },
  methods: {
    changeTab(type) {
      if(this.Permission.indexOf(207) !== -1) {
        // 点击设备组态按钮
        if(type === 'configuration' && this.Permission.indexOf(212) !== -1) {
          this.devicesBtn = 'success'
          this.allBtn = ''
          this.devicesTab = true
          this.allTab = false
          // 清除系统总览的计时器
        }else if(type === 'all' && this.Permission.indexOf(211) !== -1) { // 点击系统总览
          this.devicesBtn = ''
          this.allBtn = 'success'
          this.devicesTab = false
          this.allTab = true
          // 清除设备组态的计时器
        }else{
          this.$message.warning('权限不足，无权操作！')
        }
      }else{
        this.$message.warning('权限不足，无权操作！')
      }
    }
  }
  
}
</script>
<style scoped>
.monitor{
  display: flex;

}
.home{
  padding: 1% 2%;
}
</style>